import api from './api';

export const notificationService = {
  getAll: (params = {}) => api.get('/notifications/', { params }),
  markRead: (id) => api.patch(`/notifications/${id}/read`),
  markAllRead: () => api.post('/notifications/mark-all-read'),
};
